import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/mui";
import { Stack, Typography, Alert } from "@mui/material";

import { DetailSection, FieldGrid, FieldItem } from "components/detail";

export const AlarmShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading, isError } = queryResult;
    const record = data?.data;

    return (
        <Show
            isLoading={isLoading}
            title={
                <Typography variant="h5">
                    푸시알림 상세{record?.id ? ` · ${record.id}` : ""}
                </Typography>
            }
        >
            {isError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    푸시알림 정보를 불러오지 못했습니다.
                </Alert>
            )}

            <Stack spacing={2}>
                <DetailSection title="기본 정보">
                    <FieldGrid columns={2}>
                        {/* 원본이 raw 값을 그대로 노출했으므로 매핑 없이 유지 */}
                        <FieldItem label="유형" value={record?.dtype} />
                        <FieldItem label="메시지" span={2} value={record?.message} />
                        <FieldItem label="발송일" value={record?.createdDate} />
                    </FieldGrid>
                </DetailSection>
            </Stack>
        </Show>
    );
};
